













import {
  defineComponent,
  PropType,
  ref,
  watch,
  computed,
} from '@vue/composition-api'
import { string } from 'prop-types'

import FormSelect from '@/components/organisms/c/FormSelect.vue'
import ExtractConditionRowLayout from '@/components/organisms/h/layout/ExtractConditionRowLayout.vue'
import { formSelectExtractCondition } from '@/types/entities'

export default defineComponent({
  components: {
    FormSelect,
    ExtractConditionRowLayout,
  },
  props: {
    title: {
      type: String as PropType<string>,
      default: '',
    },
    required: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    options: {
      default: [],
    },
    defaultSelected: {
      default: null,
    },
  },
  /*********************************
   * 抽出条件変更時の処理
   *********************************/
  methods: {
    changeSelected: function (param: string) {
      console.log('changeSelected', param)
      this.$emit('changeSelected', param)
    },
  },
})
